import React, { useState } from 'react';
import styled from 'styled-components';
import { useInput } from './FormHooks'; //Custom hook for input handling
import colors from '../../styles/colors';
import axios from 'axios';
import building from '../../images/client/cardiogram.svg';
import craneTruck from '../../images/client/crane-truck.svg';
import crane from '../../images/client/crane.svg';
import { contactApiUrl } from '../../../util';

const FORM_SUBMIT_API_GATEWAY = contactApiUrl;

const BaseForm = ({ className }) => {
  const {
    value: firstName,
    bind: bindFirstName,
    reset: resetFirstName
  } = useInput('');

  const {
    value: lastName,
    bind: bindLastName,
    reset: resetLastName
  } = useInput('');

  const { value: phone, bind: bindPhone, reset: resetPhone } = useInput('');

  const { value: email, bind: bindEmail, reset: resetEmail } = useInput('');

  const { value: comment, bind: bindComment, reset: resetComment } = useInput(
    ''
  );
  const [hasNotice, setHasNotice] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState('');
  const [hasSuccess, setHasSuccess] = useState(false);
  const [success, setSuccess] = useState('');

  const handleSubmit = e => {
    e.preventDefault();
    console.log('url: ', FORM_SUBMIT_API_GATEWAY);
    axios
      .post(FORM_SUBMIT_API_GATEWAY, {
        firstName,
        lastName,
        phone,
        email,
        comment
      })
      .then(handleSuccess)
      .catch(handleError);
  };

  const handleError = error => {
    setHasNotice(true);
    clearSuccess();
    // Add an error to state
    setHasError(true);
    setError(`Oops, we had a problem. Mind trying one more time?`);
  };

  const handleSuccess = _ => {
    setHasNotice(true);
    clearError();
    setHasSuccess(true);
    setSuccess(`Thank you, we'll be in touch!`);
    resetForm();
  };

  const clearError = _ => {
    setHasNotice(false);
    setHasError(false);
    setError('');
  };

  const clearSuccess = _ => {
    setHasNotice(false);
    setHasSuccess(false);
    setSuccess('');
  };

  const resetForm = _ => {
    resetFirstName();
    resetLastName();
    resetPhone();
    resetEmail();
    resetComment();
  };

  return (
    <div className={className}>
      <div className='form-header'>
        <span>Let's </span>
        <span>work together</span>
      </div>
      {hasNotice && (
        <div className='notice'>
          {hasError && <span className='error'>{error}</span>}
          {hasSuccess && <span className='success'>{success}</span>}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className='name-row'>
          <input
            value={firstName}
            {...bindFirstName}
            placeholder='First Name'
            type='text'
            name='firstName'
            required
          />
          <input
            value={lastName}
            {...bindLastName}
            placeholder='Last Name'
            type='text'
            name='lastName'
            required
          />
        </div>
        <div className='form-row'>
          <input
            value={phone}
            {...bindPhone}
            placeholder='Phone'
            type='tel'
            name='phone'
          />
        </div>
        <div className='form-row'>
          <input
            value={email}
            {...bindEmail}
            placeholder='Email'
            type='email'
            name='email'
            required
          />
        </div>
        <div className='form-row'>
          <textarea
            value={comment}
            {...bindComment}
            placeholder='How can we help?'
            name='comment'
            rows='5'
            required
          />
        </div>

        <button className='form-submit' type='submit'>
          Send &raquo;
        </button>
      </form>
      <div className='form-meta'>
        <div className='form-meta-item'>
          <img className='icon' src={building} alt='' width='60' height='70' />
          <div className='icon-text'>
            <span>single &amp; multi-story projects</span> <br />
            <span className='icon-sub-text'>
              hospitals &middot; schools &middot; commercial &middot; retail
              &middot; custom
            </span>
          </div>
        </div>
        <div className='form-meta-item'>
          <img
            className='icon'
            src={craneTruck}
            alt=''
            width='60'
            height='70'
          />
          <div className='icon-text'>
            <span>3 ton projects</span>
          </div>
        </div>
        <div className='form-meta-item'>
          <img className='icon' src={crane} alt='' width='60' height='70' />
          <div className='icon-text'>
            <span>3000 ton projects</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const Form = styled(BaseForm)`
  width: 100%;
  background: ${colors.lightGray};
  min-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .notice {
    margin: 10px auto;
    width: 80%;
    .error {
      padding: 5px;
      border-radius: 3px;
      border: 1px solid ${colors.red};
      background: #fff;
    }
    .success {
      padding: 5px;
      border-radius: 3px;
      border: 1px solid green;
      background: #fff;
    }
  }

  .form-meta {
    .form-meta-item {
      display: flex;
      flex-direction: row;
      margin-bottom: 35px;
    }
    .icon {
      opacity: 0.4;
    }
    .icon-text {
      color: ${colors.copyIcons};
      text-transform: uppercase;
      font-size: 1em;
      padding-top: 5%;
      padding-left: 15px;
      .icon-sub-text {
        font-size: 0.7em;
      }
    }
  }

  .form-header {
    text-transform: uppercase;
    margin: 10px auto;
    margin-top: 40px;
    width: 80%;
    font-size: 1.3em;
    vertical-align: middle;
    span:nth-of-type(2) {
      font-weight: bold;
    }
  }

  form {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10px;
    width: 80%;
  }
  input,
  textarea {
    padding: 5px;
  }
  input::placeholder,
  textarea::placeholder {
    text-transform: uppercase;
  }

  .form-row,
  .name-row {
    width: 100%;
    margin-bottom: 10px;
    margin-left: -5px;
    
  }
  .name-row {
    display: flex;
    justify-content: space-between;
    input {
      width: 48%;
    }
  }
  .form-row {
    input,
    textarea {
      width: 100%;
    }

  }
  button {
    text-transform: uppercase;
    border: 1px solid ${colors.darkGray};
    color: ${colors.darkGray};
    padding: 5px;
    width: 100px;
    float: right;
  }
  .form-meta {
    width: 80%;
    margin: 10px auto;
  }
  .form-submit {
    cursor: pointer;
  }
`;

export default Form;
